import styled from "styled-components";

export const OurPlansWrapper = styled.div`
  padding: 24px;
  background-color: ${(props) => props.theme.backgroundColor};
  height: 100%;
  border-radius: 5px;
  margin: 0 10px;
  max-width: 365px;

`;

export const PlansButton = styled.button`
  margin-top: 24px;
  background-color: ${(props) => props.theme.selectColor};
  padding: 24px 16px;
  border-radius: 5px;
  width: 100%;
  border: unset;
  box-shadow: -3px 4px 11px 0px rgba(0, 0, 0, 0.2);
  text-align: left;
  position: relative;

  span {
    font-size: 1.3rem;
    text-align: center;
  }
  p {
    margin-top: 5px;
    span {
      font-size: 0.9rem;
      text-decoration: line-through;
      color: ${props => props.theme.fontColor}80;
  }
  }
`;

export const DiscountTag = styled.div`
  position: absolute;
  right: 10px;
  top: 0;
  bottom: 0px;
  display: flex;
  align-items: center;
  font-size: 0.8rem;
  p {
    margin: 0;
    padding: 4px;
    color: ${(props) => props.theme.secondary};
    background-color: ${(props) => props.theme.secondary}1a;
    border-radius: 5px;
  }
`;